import { defineComponent, computed, createElementBlock, openBlock, normalizeStyle, normalizeClass } from 'vue';
import loadIcons from './basler-components.es364.js';

const _hoisted_1 = ["innerHTML"];
const defaultIconName = "accessory-type";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Icon",
  props: {
    name: {},
    size: { default: "dynamic" },
    color: {},
    scaleFactor: {}
  },
  setup(__props) {
    const props = __props;
    const { icons } = loadIcons();
    const defaultIcon = icons.find((icon2) => icon2.name === defaultIconName);
    const icon = computed(() => {
      return icons.find((icon2) => icon2.name === props.name) || defaultIcon;
    });
    const svg = computed(() => {
      return icon.value?.module ?? defaultIcon;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(["icon", `icon--${icon.value?.name}`, `icon--${props.size}`]),
        innerHTML: svg.value,
        style: normalizeStyle({
          "--color-icon": props.color,
          "--scale-factor": props.scaleFactor
        }),
        "aria-hidden": "true"
      }, null, 14, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
